import { OrderBasket, OrderFormData } from './index';
var Order = /*@__PURE__*/ (function () {
    function Order() {
        this.responseCode = 'C.G.200.0';
        this.valid = true;
        this.errors = null;
        this.orderId = '';
        this.formData = new OrderFormData();
        this.basket = new OrderBasket();
    }
    Order.prototype.getFormData = function () {
        return this.formData;
    };
    Order.prototype.getBasket = function () {
        return this.basket;
    };
    return Order;
}());
export { Order };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.ts
// module id = null
// module chunks = 